<template>
    <form action="#" @submit.prevent="submitFormAtivo" data-vv-scope="formulario" class="form-ativo">
        <div class="form-group"><!-- Ativo -->
            <label class="form-label" for="ativo">Ativo</label>
            <div class="multiselect-group">
                <multiselect v-model="formularioAtivo.ativo.value" :options="formularioAtivo.ativo.options"
                    :searchable="true" :internalSearch="false" :show-labels="false"
                    class="form-control m-0 p-0" :class="{'is-invalid': errors.has('formulario.ativo')}"
                    v-validate="'required'" name="ativo" key="ativo"
                    placeholder="Nome ou CNPJ do ativo" track-by="key" label="value"
                    :loading="formularioAtivo.ativo.isLoading" @search-change="listarAtivos" @input="selecionaAtivo"
                >
                    <template slot="noResult">Nenhum ativo foi encontrado. Verifique o termo buscado e tente novamente</template>
                    <template slot="noOptions">Digite para começar a buscar</template>
                    <template slot="option" slot-scope="props">
                        <p class="option__desc">{{ props.option.value }}</p>
                    </template>
                    <p slot="singleLabel" slot-scope="item">{{item.option.value}}</p>
                </multiselect>
                <div v-if="formularioAtivo.ativo.value" class="multiselect-close" @click="formularioAtivo.ativo.value = null">
                    <img src="img/icons/ico-close.svg" alt="">
                </div>
            </div>
            <!-- <span v-show="errors.has('formulario.ativo')" class="invalid-feedback">{{ errors.first('formulario.ativo') }}</span> -->
        </div>
        <div class="form-group relative"><!-- Data de Aplicação -->
            <label class="form-label" for="dataAplicacao">Data da aplicação</label>
            <div class="input-icon">
                <vue-pikaday ref="datePicker" v-model="formularioAtivo.dataAplicacao.value" :options="datePickerOptions"
                    placeholder="Selecione ou digite uma data" v-validate="'dataValida'"
                    class="form-control" :class="{'is-invalid': errors.has('formulario.dataAplicacao')}"
                    name="dataAplicacao" autocomplete="off"
                    :disabled="datePickerOptions.disabled" :key="datePickerOptions.key"
                />
                <div class="icon" @click="$refs.datePicker.$el.click()"><img src="img/icons/ico-calendar.svg"/></div>
            </div>
            <div ref="pikadayContainer" class="pikaday-container"></div>
            <!-- <span v-show="errors.has('formulario.dataAplicacao')" class="invalid-feedback">{{ errors.first('formulario.dataAplicacao') }}</span> -->
        </div>
        <div class="form-group" @keydown="$event.key === '-' ? $event.preventDefault() : null"><!-- Valor Aplicado -->
            <label class="form-label" for="valor aplicado">Valor da aplicação (R$)</label>
            <div class="input-icon">
                <money v-model="formularioAtivo.valorAplicado.value" v-bind="formularioAtivo.valorAplicado.mask" 
                    v-validate="'required|min_value:0.01'" 
                    class="form-control" :class="{'is-invalid': errors.has('formulario.valor aplicado')}" 
                    name="valor aplicado" key="valor aplicado" maxlength="22"
                >
                </money>
                <div class="icon" v-if="formularioAtivo.valorAplicado.value > 0" @click="formularioAtivo.valorAplicado.value = 0"><img src="img/icons/ico-close.svg" alt=""></div>
            </div>            
            <!-- <span v-show="errors.has('formulario.valor aplicado')" class="invalid-feedback">{{ errors.first('formulario.valor aplicado') }}</span> -->
        </div>
        <div class="form-group">
            <label class="form-label no-change">Comparar com</label>
            <div class="checkbox-group">
                <div v-for="(indexador, index) in indexadores" class="checkbox c-checkbox" :key="index">
                    <label>
                        <input type="checkbox" :value="indexador" v-model="indexadoresSelecionados"/>
                        <span class="fa fa-check"></span>{{indexador.nomeIndexador}}
                    </label>
                </div>
            </div>
        </div>
        <button class="btn btn-submit" type="submit" :disabled="!formValid">SIMULAR</button>
    </form>
</template>

<script>
import Vue from "vue"
import Multiselect from "vue-multiselect"
import { Money } from 'v-money'
import SimuladorService from "@/app/services/Simulador/simulador.service";
import moment from 'moment';
import SpinnerService from '../../services/spinner.service';

export default {
    components: {
        Multiselect,
        Money
    },
    data() {
        return {
            formularioAtivo: {
                tipo: {
                    value: null,
                    options: [],
                    isLoading: false
                },
                ativo: {
                    value: null,
                    options: [],
                    isLoading: false
                },
                dataAplicacao: {
                    value: null
                },
                valorAplicado: {
                    value: 0,
                    mask: {
                        decimal: ',',
                        thousands: '.',
                        precision: 2,
                        masked: false
                    }
                }
            },
            datePickerOptions: { // Configuração do datepicker
                container: null,
                format: "DD/MM/YYYY",
                minDate: null,
                maxDate: null,
                disableWeekends: true,
                disableDayFn(data) {
                    return !this.datasValidas.includes(moment(data, 'YYYY-MM-DD').format("YYYY-MM-DD"))
                },
                i18n: {
                    previousMonth: "Mês anterior",
                    nextMonth: "Próximo mês",
                    months: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
                    weekdays: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
                    weekdaysShort: ["D", "S", "T", "Q", "Q", "S", "S"],
                },
                datasInvalidas: [],
                datasValidas: [],
                disabled: false,
                key: 1
            },
            datePickerVisible: false,
            indexadoresSelecionados: [],
            timeout: null
        }
    },
    methods: {
        selecionaAtivo() {
            if (this.formularioAtivo.ativo.value) {
                SimuladorService.obterDatasValidasAtivo(this.formularioAtivo.ativo.value.key).then(resposta => {
                    if(resposta.sucesso) {
                        let datasFormatadas = [];
                        for (let i in resposta.datas) {
                            datasFormatadas.push(moment(resposta.datas[i], "YYYY-MM-DD").format("YYYY-MM-DD"))
                        } 
                        this.datePickerOptions.datasValidas = datasFormatadas
                    }
                    this.datePickerOptions.key++
                });
            } else {
                this.datasValidas = []
            }
        },
        abrir() {
            this.formularioAtivo.tipo.value = this.formularioAtivo.tipo.options[0];
            this.formularioAtivo.ativo.value = null;
            this.formularioAtivo.dataAplicacao.value = null;
            this.formularioAtivo.valorAplicado.value = 0;

            // Resetar veevalidate
            this.$nextTick(() => {
                this.errors.clear();
                this.$nextTick(() => {
                    this.$validator.reset();
                });
            });

           this.$refs['modalAdicionarAtivo'].open();
        },
        obterDatasInvalidas() {
            this.datePickerOptions.disabled = true
            
            SimuladorService.obterDatasInvalidas().then(resposta => {
                if (resposta.sucesso && resposta.datas) {
                    // O formato precisa vim certo para o pikadate proibir as datas invalidas
                    let datasFormatadas = [];

                    for (let i in resposta.datas) {
                        datasFormatadas.push(moment(resposta.datas[i], "YYYY-MM-DD").format("YYYY-MM-DD"))
                    } 

                    this.datePickerOptions.datasInvalidas = datasFormatadas
                }
                this.datePickerOptions.disabled = false
                this.datePickerOptions.key++
            });
        },
        listarTiposInvestimento() {
            let select = this.formularioAtivo.tipo
            select.isLoading = true

            SimuladorService.obterTiposInvestimento().then(resposta => {
                if (resposta.sucesso && resposta.tipos) {
                    select.options = [];

                    for (let i = 0; i < resposta.tipos.length; i++) {
                        const tipo = resposta.tipos[i];
                        select.options.push({ key: tipo.codigo, value: tipo.descricao });
                    }
                    select.value = select.options[0];
                }
                select.isLoading = false
            });
        },
        listarAtivos(query) {
            if (query == '' || query == null) return // Evitar requisição com query vazia
            let select = this.formularioAtivo.ativo
            select.isLoading = true

            // Tratativa para iniciar a busca algum tempo após o usuário parar de digitar
            clearInterval(this.typingTimeout)
            this.typingTimeout = setTimeout(() => {
                let codigoTipoInvestimento = this.formularioAtivo.tipo.value ? this.formularioAtivo.tipo.value.key : 0;

                // Trata query para tirar pontuação de CNPJ
                let cnpj = query.replaceAll(/[.\-\/]/g, "")
                if (/^[0-9]+$/.test(cnpj)) {
                    query = cnpj
                }

                SimuladorService.buscarAtivos(query, codigoTipoInvestimento).then(resposta => {
                    if (resposta.sucesso && resposta.ativos) {
                        select.options = resposta.ativos.map(el => {
                            return {key: el.codigo, value: el.nome}
                        });
                    }
                    select.isLoading = false
                });
            }, 350);
        },
        submitFormAtivo(scope) {
            this.$validator.validateAll(scope).then((result) => {
                if (result) {
                    if (this.totalAtivos >= 6) {
                        Vue.notify({
                            type: "warn",
                            group: 'principal',
                            text: "O limite de 6 ativos / indexadores foi atingido.",
                            duration: 10000
                        });
                    } else {
                        SpinnerService.show();
                        SimuladorService.salvarAtivoSelecionado({
                            token: this.$route.query.token,
                            codigoAtivo: this.formularioAtivo.ativo.value.key,
                            dataReferencia: moment(this.formularioAtivo.dataAplicacao.value).format("YYYY-MM-DD"),
                            valor: this.formularioAtivo.valorAplicado.value
                        }).then((retorno) => {
                            SpinnerService.hide();

                            let f = this.formularioAtivo;
                            f.ativo.value = f.dataAplicacao.value = null;
                            f.valorAplicado.value = 0;

                            // Verificar se a data informada é menor que a salva na store. Assim garantimos que os valores corretos serão carregados
                            // nas tabelas caso a data de inicio seja a menor possível
                            let datas = this.$store.getters.getDatasPeriodo;
                            let menorDataMoment = moment(datas.menorData);
                            let novaDataMoment = moment(this.formularioAtivo.dataAplicacao.value);

                            if (novaDataMoment > menorDataMoment) {
                                this.$store.commit("setDatas", {
                                    maiorData: datas.maiorData,
                                    menorData: novaDataMoment.toDate()
                                });
                            }

                            if (retorno.sucesso) {
                                this.$store.commit('addAtivo');

                                Vue.notify({
                                    title: 'Sucesso',
                                    type: "success",
                                    group: 'principal',
                                    text: "Ativo adicionado com sucesso.",
                                    duration: 5000
                                });
                                
                                this.$emit('acaoRealizada', { tipo: "novoAtivoSalvo" });
                            } else {
                                Vue.notify({
                                    title: 'Erro',
                                    type: "danger",
                                    group: 'principal',
                                    text: "Ocorreu um erro ao adicionar o ativo.",
                                    duration: 5000
                                });
                            }
                        });
                    }
                }
            });
        }
    },
    computed: {
        formValid() {
            let f = this.formularioAtivo
            return this.errors.items.length == 0
                && f.tipo.value != null
                && f.dataAplicacao.value != null
                && f.ativo.value != null && f.ativo.value.key > 0
                && f.valorAplicado.value > 0;
        },
        indexadores() {
            return this.$store.getters.getIndexadores;
        },
        totalAtivos() {
            return this.$store.getters.getQuantidadeAtivos + this.$store.getters.getSelecionados.length;
        }
    },
    watch: {
        indexadoresSelecionados(val) {
            clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    if (val.length == 0) {
                        this.indexadoresSelecionados.push(this.indexadores.find(el => el.id == 1));
                    } else if (this.totalAtivos >= 6 && val.length > this.$store.getters.getSelecionados.length) {
                        Vue.notify({
                            type: "warn",
                            group: 'principal',
                            text: "O limite de 6 ativos / indexadores foi atingido.",
                            duration: 10000
                        });
                        SpinnerService.hide();
                        this.indexadoresSelecionados = this.$store.getters.getSelecionados;
                    } else {
                        this.$store.commit("setSelecionados", val.map(el => el.codigoIndexador));
                    }
                }, 800)
        }
    },
    beforeMount() {
        this.$validator.extend("dataValida", {
            getMessage: `A data selecionada é inválida`,
            validate: (value) => { 
                return !this.datePickerOptions.datasInvalidas.includes(moment(value).format("YYYY-MM-DD")) || !this.datePickerOptions.datasValidas.includes(moment(value).format("YYYY-MM-DD"))
            }
        });
        this.obterDatasInvalidas()
        this.listarTiposInvestimento()
        this.indexadoresSelecionados = this.$store.getters.getSelecionados;
    },
    mounted() {
        this.datePickerOptions.container = this.$refs.pikadayContainer;
        SimuladorService.obterQuantidadeAtivos({token: this.$route.query.token}).then(response => {
            if (response.sucesso) {
                this.$store.commit('setQuantidadeAtivos', response.quantidadeAtivos);
            }
        })
    }
}
</script>

<style lang="scss">
    .form-ativo {
        .form-group {
            margin-bottom: 32px;

            &.relative { position: relative; }

            label {
                color: $font-color !important;
                font-size: 14px;
                line-height: 20px;
                margin-bottom: 16px;

                &.no-change { font-weight: normal !important; }
            }
            
            .multiselect-group {
                position: relative;

                .multiselect:not(.borderless-multiselect) {
                    .multiselect__select {
                        padding: 12px 0 8px;
                        width: 12px;
                    }
                    
                    .multiselect__tags {
                        border-top: none !important;
                        border-left: none !important;
                        border-right: none !important;
                        border-radius: 0;
                        border-color: rgba(36, 36, 36, 0.35);
                        padding: 9px 0 0 !important;

                        .multiselect__spinner {
                            margin-right: 12px;
                        }

                        .multiselect__input {
                            padding: 0;
                            margin-bottom: 0;
                        }

                        .multiselect__single {
                            padding-left: 0;
                            // max-width: 90%;
                            > p {
                                margin-bottom: 0;
                                max-width: 90%;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            }
                        }
                    }

                    .multiselect__tags, .multiselect__tags > .multiselect__placeholder, .multiselect__input {
                        font-size: 16px;
                    }

                    .multiselect__content-wrapper {
                        min-width: 100%;
                        overflow-x: hidden;

                        .multiselect__content {
                            max-width: 100%;

                            .multiselect__element {
                                min-width: 100%;
                                width: fit-content;

                                .multiselect__option {
                                    background: transparent !important;

                                    &.multiselect__option--selected p { opacity: 1; }

                                    p {
                                        margin-bottom: 0;
                                        width: calc(100% - 1px);
                                        white-space: nowrap;
                                        text-overflow: ellipsis;
                                        overflow: hidden;
                                        color: $font-color;
                                        opacity: .6;
                                    }
                                }

                                &:hover {
                                    p {
                                        opacity: 1;
                                    }
                                }
                            }
                        }
                    }
                }

                .multiselect-close {
                    position: absolute;
                    width: 24px;
                    height: 38px;
                    right: 0;
                    top: 1px;
                    padding: 4px 0 4px 8px;
                    text-align: center;
                    cursor: pointer;
                }
            }

            input.form-control {
                border-top: none !important;
                border-left: none !important;
                border-right: none !important;
                border-radius: 0 !important;
                padding-left: 0;
                box-shadow: none;
                border-color: rgba(36, 36, 36, 0.35);
            }

            .checkbox-group {
                display: flex;
                flex-wrap: wrap;
                border-bottom: 1px solid rgba(36, 36, 36, 0.1);

                .checkbox {
                    flex: 45%;
                    margin-left: 0;
                    margin-right: 14px;
                    > label {
                        display: flex;
                        align-items: center;

                        input:checked + span {
                            background-color: $secondary-color-alt;
                            border-color: $secondary-color-alt;
                        }

                        span {
                            height: 12px;
                            width: 12px;
                            margin-right: 10px;
                            border-color: $font-color;
                            
                            &::before {
                                font-size: 8px;
                                line-height: 10px;
                            }
                        }
                    }
                }
            }
        }

        .btn-submit {
            width: 100%;
            background: $secondary-color-alt linear-gradient(105.23deg, $secondary-color 0%, $secondary-color-alt 100%);
            border: none;
            border-radius: 64px;
            padding: 14px;
            margin-top: 20px;
            color: $font-color !important;
            opacity: 1;
            font-size: 14px;
            font-weight: normal;
            transition: background 0s;

            &:disabled { background: #E8E8E8 !important; }
            &:hover {
                background: $secondary-color radial-gradient(circle, transparent 1%, $secondary-color-alt 1%) center/15000%;
            }
            &:focus { transition: background .8s; }

            &:active {
                background-color: $secondary-color-alt;
                background-size: 100%;
                transition: background 0s;
            }
        }
    }

    .pika-single.custom {
        .pika-lendar {
            width: 288px;
            
            .pika-title {
                padding: 6px 12px 3px;
                background: transparent;
                font-weight: 600;
                color: $font-color;
                display: block;
                
                .pika-label {
                    background: transparent;
                    font-size: 14px;
                    font-weight: bold;
                }

                // .pika-select { height: 10px; }

                .pika-prev, .pika-next {
                    margin-top: 7px;
                    width: 8px;
                    &:not(.is-disabled) { opacity: 1; }
                }
                .pika-prev:before {
                    content: '<';
                }
                .pika-next:before {
                    content: '>';
                }
            }
        }
    }
</style>